import {
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
} from "V2.0/common/dropdown";

import {
  EllipsisHorizontalIcon,
  FolderIcon,
  UserCircleIcon,
  UserMinusIcon,
} from "@heroicons/react/24/outline";

export default UserProfileActions;

interface UserProfileActionsProps {
  onManageWorkspaceAccess: () => void;
  onModifyUserRole: () => void;
  onDeactivateUser: () => void;
}

function UserProfileActions(props: UserProfileActionsProps) {
  const { onManageWorkspaceAccess, onModifyUserRole, onDeactivateUser } = props;

  const profileActions = [
    {
      name: "Manage Workspace Access",
      icon: <FolderIcon className="size-4" />,
      onClick: onManageWorkspaceAccess,
    },
    {
      name: "Deactivate",
      icon: <UserMinusIcon className="size-4" />,
      onClick: onDeactivateUser,
    },
    {
      name: "Modify Role",
      icon: <UserCircleIcon className="size-4" />,
      onClick: onModifyUserRole,
    },
  ];

  const renderDropdownItems = profileActions.map((action) => {
    return (
      <DropdownItem
        onClick={action.onClick}
        disabled={!action.onClick}
      >
        <div className="flex items-center gap-x-2">
          {action.icon}
          {action.name}
        </div>
      </DropdownItem>
    );
  });

  return (
    <Dropdown>
      <DropdownButton color="white">
        <EllipsisHorizontalIcon />
      </DropdownButton>

      <DropdownMenu anchor={{ to: "bottom start" }}>
        {renderDropdownItems}
      </DropdownMenu>
    </Dropdown>
  );
}
